module.exports = __webpack_public_path__ + "static/media/education-object-1-1-0.293fe0bd.png";